(()=>{
 const reducedMotion=matchMedia('(prefers-reduced-motion: reduce)');
 document.querySelectorAll('[data-review-slider]').forEach((track,sliderIndex)=>{
  const label=track.dataset.reviewSlider;
  track.classList.add('review-slider-track');
  track.id=track.id||`review-slider-${sliderIndex+1}`;
  track.tabIndex=0;
  track.setAttribute('role','region');
  track.setAttribute('aria-roledescription','carousel');
  track.setAttribute('aria-label',label);
  const controls=document.createElement('div');
  controls.className='review-slider-controls';
  const status=document.createElement('span');status.className='review-slider-status';
  status.setAttribute('aria-live','polite');status.setAttribute('aria-atomic','true');
  function button(direction,symbol){
   const el=document.createElement('button');el.type='button';el.textContent=symbol;
   el.setAttribute('aria-label',`${direction} ${label.toLowerCase()}`);el.setAttribute('aria-controls',track.id);return el;
  }
  const previous=button('Previous','‹'),next=button('Next','›');
  controls.append(status,previous,next);track.after(controls);
  const cards=()=>[...track.children].filter(card=>!card.hidden);
  const max=()=>Math.max(0,track.scrollWidth-track.clientWidth);
  function update(){
   const items=cards(),bounds=track.getBoundingClientRect();
   const visible=items.map((card,index)=>({index,box:card.getBoundingClientRect()})).filter(({box})=>box.left>=bounds.left-3&&box.right<=bounds.right+3);
   const first=visible[0]?.index??0,last=visible.at(-1)?.index??first;
   status.textContent=items.length?`${first+1}${last!==first?'–'+(last+1):''} of ${items.length}`:'No reviews';
   previous.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft>=max()-2;
   controls.hidden=max()<=2;
  }
  function move(direction){
   const first=cards()[0];if(!first)return;
   const step=first.getBoundingClientRect().width+(parseFloat(getComputedStyle(track).columnGap)||0);
   track.scrollTo({left:Math.max(0,Math.min(max(),track.scrollLeft+direction*step)),behavior:reducedMotion.matches?'instant':'smooth'});
  }
  previous.onclick=()=>move(-1);next.onclick=()=>move(1);
  track.addEventListener('keydown',event=>{
   if(event.target!==track)return;
   if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}
   if(['Home','End'].includes(event.key)){event.preventDefault();track.scrollTo({left:event.key==='Home'?0:max(),behavior:reducedMotion.matches?'instant':'smooth'})}
  });
  let drag=null;
  track.addEventListener('pointerdown',event=>{
   if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('button,a,input,select'))return;
   drag={id:event.pointerId,x:event.clientX,left:track.scrollLeft,moved:false};
  });
  track.addEventListener('pointermove',event=>{
   if(!drag||drag.id!==event.pointerId)return;
   if(!drag.moved&&Math.abs(event.clientX-drag.x)>5){drag.moved=true;track.classList.add('is-dragging');track.setPointerCapture(event.pointerId)}
   if(drag.moved){event.preventDefault();track.scrollLeft=drag.left+drag.x-event.clientX}
  });
  const endDrag=()=>{if(!drag)return;const id=drag.id;drag=null;track.classList.remove('is-dragging');if(track.hasPointerCapture(id))track.releasePointerCapture(id);update()};
  track.addEventListener('pointerup',endDrag);track.addEventListener('pointercancel',endDrag);track.addEventListener('lostpointercapture',endDrag);
  track.addEventListener('pointerleave',()=>{if(drag&&!drag.moved)endDrag()});
  let timer;track.addEventListener('scroll',()=>{clearTimeout(timer);timer=setTimeout(update,100)},{passive:true});
  new ResizeObserver(update).observe(track);
  document.getElementById('reviewFilter')?.addEventListener('change',()=>{
   if(track.classList.contains('written-review-track')){track.scrollLeft=0;requestAnimationFrame(update)}
  });
  update();
 });
})();
